import { BaseEntity } from "yt-ng-framework";

export class FirmaObjekatView extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string  = null;
    FirmaNaziv: string;
    Gln: string = null;
    MestoNaziv: string  = null;
    Adresa: string  = null;
    PostBroj: string  = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Naziv=input.Naziv;
        this.FirmaNaziv = input.FirmaNaziv;
        this.Gln=input.Gln;
        this.MestoNaziv=input.MestoNaziv;
        this.Adresa=input.Adresa;
        this.PostBroj=input.PostBroj;
        return this;
    }

    Serialize(input:FirmaObjekatView){
        return input;
    }
}